import { useState, useEffect } from "react";
import { getPricedOrders } from "../../services/order";
import { PRICED_ORDERS_CRUMBS } from "../../constants/crumbs";
import PortalBreadcrumb from "../UI/Breadcrumb/PortalBreadcrumb/PortalBreadcrumb";
import classes from "./PricedOrders.module.css";
import Loading from "../UI/Loading/Loading";
import EmptyContent from "../UI/EmptyContent/EmptyContent";
import PricedOrderListItem from "./PricedOrderListItem/PricedOrderListItem";

const PricedOrders = () => {
  const [pricedOrders, setPricedOrders] = useState([]);
  const [isPricedOrdersLoading, setIsPricedOrdersLoading] = useState(true);
  const [pricedOrdersLoadingError, setPricedOrdersLoadingError] = useState("");

  useEffect(() => {
    const fetchPricedOrders = async () => {
      try {
        setIsPricedOrdersLoading(true);
        const response = await getPricedOrders();
        const {
          data: { orderList },
        } = response;
        setPricedOrders(orderList);
      } catch (err) {
        setPricedOrdersLoadingError("! حدث خطأ أثناء تحميل الطلبات المسعرة");
      } finally {
        setIsPricedOrdersLoading(false);
      }
    };

    fetchPricedOrders();
  }, []);

  return (
    <div className={classes["priced-orders"]}>
      <PortalBreadcrumb paths={PRICED_ORDERS_CRUMBS} />
      {isPricedOrdersLoading ? (
        <Loading className={classes["priced-orders__loading"]} />
      ) : pricedOrders.length === 0 || pricedOrdersLoadingError ? (
        <EmptyContent
          className={classes["priced-orders__empty"]}
          message="لا يوجد طلبات مسعرة لعرضها !"
          withAction
        />
      ) : (
        <ul className={classes["priced-orders__list"]}>
          {pricedOrders.map((order, index) => (
            <PricedOrderListItem key={index} orderId={order.id} />
          ))}
        </ul>
      )}
    </div>
  );
};

export default PricedOrders;
